import imgOne from '../assets/futcha-one.webp';
import imgTwo from '../assets/futcha-two.webp';
import imgThree from '../assets/futcha-three.webp';
import imgFour from '../assets/futcha-four.webp';
import imgFive from '../assets/futcha-five.webp';
import imgSix from '../assets/futcha-six.webp';
import imgSeven from '../assets/futcha-seven.webp';
import imgEight from '../assets/futcha-eight.webp';
import imgNine from '../assets/futcha-nine.webp';

const Images = [
    {
        id: "216ec7fc-1bea-47a2-a160-5f034df36e0e",
        title: "Sabulevskii",
        cover: imgOne,
        alt: "une personne portant un casque et des lunettes de protection",
        text: "The russian photographer, show the world through the prism of his perception. This is part of his way to make a great movie and game developer.",
        source: "https://unsplash.com/fr/@dweller_sgra"
    },
    {
        id: "c29fe3b7-cdbf-4669-83ad-10ae9eba6884",
        title: "Shen",
        cover: imgTwo,
        alt: "squelette humain doré sur fond noir",
        text: "Wesley’s work is available on unsplash - If you want to know more about the artist click on the link below.",
        source: "https://unsplash.com/fr/@wesleyshen"
    },
    {
        id: "7f7b5601-d58e-4bbc-8d7b-5fce89b9fb00",
        title: "Owo",
        cover: imgThree,
        alt: "silhouette di donna in piedi all'interno della stanza piena di monitor",
        text: "Yomex’s work is available on unsplash - If you want to know more about the artist click on the link below.",
        source: "https://unsplash.com/fr/@yomex4life"
    },
    {
        id: "6876a93d-8342-4310-9deb-9e3dfe62d540",
        title: "Tromeur",
        cover: imgFour,
        alt: "Un robot debout sur un pied",
        text: "Tromeur’s work is available on unsplash - If you want to know more about the artist click on the link below.",
        source: "https://unsplash.com/fr/@julientromeur"
    },
    {
        id: "2a517781-4731-4cca-9ac4-6af7ff17a594",
        title: "Nasa",
        cover: imgFive,
        alt: "Astronaute sur rover lunaire",
        text: "To reach for new heights and reveal the unknown so that what we do and learn will benefit all humankind.",
        source: "https://unsplash.com/fr/@nasa"
    },
    {
        id: "377e3613-bbe6-4bf4-ab67-c93a284c637f",
        title: "Nevozhai",
        cover: imgSix,
        alt: "tour Blanche",
        text: "Nevozhai’s work is available on unsplash - If you want to know more about the artist click on the link below.",
        source: "https://unsplash.com/fr/@dnevozhai"
    },
    {
        id: "8bbbe4e4-8c5b-497c-8b27-076b9d0f38e6",
        title: "Davidson",
        cover: imgSeven,
        alt: "moto de neige noire",
        text: "Davidson’s work is available on unsplash - If you want to know more about the artist click on the link below.",
        source: "https://unsplash.com/fr/@harleydavidson"
    },
    {
        id: "b0fb8943-38e6-46c3-800c-4d26b1000976",
        title: "TETrebbien",
        cover: imgNine,
        alt: "uomo con carta da parati digitale fumo rosa",
        text: "TETrebbien’s work is available on unsplash - If you want to know more about the artist click on the link below.",
        source: "https://unsplash.com/fr/@tetrebbien"
    },
    {
        id: "fbac31a7-45a7-4a8c-8f18-7b43253bbf82",
        title: "Quelle est la taille de l'univers ?",
        text: "La théorie de la relativité générale d'Einstein nous a appris que l'espace-temps pouvait se déformer comme une membrane élastique. La théorie du Big Bang, bien confirmée par l'expérience et découlant de la théorie d'Einstein, nous indique que l'espace est en expansion. Cette théorie est compatible avec l'idée que notre univers est une sorte de bulle de taille finie qui gonfle, mais aussi avec l'idée que cet univers était déjà de taille infinie au moment où a commencé son expansion. Quelle est la taille de l'univers ?",
        source: "https://www.futura-sciences.com/sciences/questions-reponses/espace-taille-univers-3424/"
    },
    {
        id: "f482b33a-eb7f-459c-b179-d7275a6aba56",
        title: "First Science Images Released ",
        text: "Les nouvelles images de la mission Euclid comprennent un amas de milliers de galaxies lointaines, démontrant les capacités uniques du vaisseau spatial. La mission Euclid, qui enquêtera sur les mystères de la matière noire et de l’énergie noire, a publié ses cinq premières images scientifiques mardi 7 novembre.L’observatoire, dirigé par l’ESA(Agence spatiale européenne) avec des contributions de la NASA, devrait commencer ses opérations scientifiques régulières début 2024. FSIR",
        source: "https://www.nasa.gov/missions/euclid/first-science-images-released-from-esa-mission-with-nasa-contributions/"
    },
    {
        id: "036c1d96-a089-4632-9783-f00794e9ced0",
        title: "Les théoriciens de l'aviation",
        text: "Si sir George Cayley inventa en 1810 sur papier le premier avion véritable, un peu plus tard, en 1842, William Henson donna la première description d'un moteur à vapeur léger. En 1845 un de ses amis Stringfellow fabriqua de magnifiques moteurs à vapeur miniatures.En 1848 il fit voler parfaitement une maquette de 3, 5 kg avec un moteur. C'était dans la cour d'une usine de CHARD comté de Sommerset, et « c'était la première fois au monde qu'un corps plus lourd que l'air volait par ses propres moyens !»",
        source: "https://www.techno-science.net/glossaire-definition/Aerospatiale.html"
    },
    {
        id: "1bf3dd86-03e5-47bc-9bd1-e39e8fb17e71",
        title: "L’Europe spatiale",
        text: "C’est un cruel anniversaire qui se profile. Le 2 décembre 2014, déstabilisés par l’arrivée subite d’Elon Musk, qui s’imposait sur le marché des lanceurs en cassant les prix, les Européens réagissaient en décidant de concevoir Ariane-6, une fusée capable de concurrencer les Falcon 9 du milliardaire. L’objectif était de parvenir à un premier vol en juillet 2020. Près de neuf ans plus tard, il n’en est rien.Pire, la société SpaceX de M.Musk domine le marché et impose ses règles. Depuis cet automne, l’Europe ne dispose plus d’accès à l’espace. « Source Le Monde »",
        source: "https://www.lemonde.fr/economie/article/2023/11/04/l-europe-spatiale-a-la-recherche-d-une-sortie-de-crise_6198158_3234.html"
    },
    {
        id: "f0efef5f-4e22-4af8-97a3-408001fa6f1c",
        title: "Assistant IT",
        text: " La médecine de précision a besoin d’outils d’aide au diagnostic qui soient fiables, robustes, précis, largement validés et démontrant un bénéfice réel et mesurable pour les patients. Il est également capital que ces systèmes digitaux soient éthiques et bénéficient d’une transparence complète tant dans leur construction que dans l’interprétation et le rendu des résultats. Dans notre étude nous avons pu démontrer qu’un assistant informatique automatisé permettait aux médecins de poser des diagnostics plus précis. « Professeur Alexandre Loupy » Assistant informatique",
        source: "https://www.myscience.fr/news/2023/un_assistant_informatique_automatise_specialise_dans_le_diagnostic_du_rejet_de_greffe-2023-inserm"
    },
    {
        id: "34eff5bb-1668-458b-acc4-5ed786be9afe",
        title: "Une coopération",
        text: " Toulouse, le 13 juin 2023 - Après trois années de recherche et de développement, Vitesco Technologies, l’un des principaux développeurs et fabricants internationaux de technologies de pointe pour la mobilité durable, présente le premier résultat de son partenariat avec le CEA (Commissariat à l’énergie atomique et aux énergies alternatives) en France. Ensemble, ils ont développé une technologie de gestion de la 'batterie commutée' (SWIBA) qui améliore encore les performances globales de la chaîne de traction des véhicules électriques.",
        source: "https://www.myscience.fr/news/2023/une_competence_concentree_dans_gestion_batteries_vitesco_technologies_france_coopere_avec_cea-2023-cea-leti"
    },
    {
        id: "f1e1b1f3-7723-4aa7-8cf3-08defb1921bf",
        title: "Nick",
        cover: imgEight,
        alt: "uomo in giacca nera",
        text: "Nick’s work is available on unsplash - If you want to know more about the artist click on the link below.",
        source: "https://unsplash.com/fr/@phil_has_eyes"
    },
    {
        id: "37e4c6e2-0f71-40a2-9045-17a7d9c5d8e1",
        title: "Intelligence artificielle et humain",
        text: "Il est certain que nous allons devoir coexister avec l'IA à différents degrés. Nous espérons pouvoir, ensemble, surmonter la plupart de nos peurs et mieux comprendre une technologie qui façonne d'ores et déjà notre avenir. De manière générale, les êtres humains n'ont jamais vécu aussi longtemps et en aussi bonne santé",
        source: "https://www.europarl.europa.eu/RegData/etudes/IDAN/2018/614547/EPRS_IDA(2018)614547_FR.pdf"
    },
    {
        id: "78c43521-2d10-420c-a98f-cdc81f3259a9",
        title: "L’actualité spatiale",
        text: "Comme le stipule exactement l’ordre : “DISH a éliminé le satellite EchoStar-7 à 122 kilomètres (km) au-dessus de son orbite géostationnaire opérationnelle, à moins des 300 km au-dessus de son orbite géostationnaire opérationnelle spécifiée dans son plan d’atténuation des débris orbitaux dans la licence de DISH. Les débris orbitaux dans l’espace mettent en péril les systèmes de communication terrestres et spatiaux du pays en augmentant le risque de dommages aux systèmes de communication par satellite. Par conséquent, il est important que le Conseil veille à ce que les titulaires de licence satellite satisfassent aux exigences d’élimination après la mission d’une manière conforme à leurs autorisations. DISH admet qu’elle n’a pas exploité le satellite EchoStar-7 conformément à son autorisation et mettra en œuvre un plan de conformité et paiera une pénalité civile de 150 000 $“.",
        source: "https://reves-d-espace.com/actualite-spatiale-octobre-2023/"
    },

]
export default Images;